import type { ProfessionalProfileDto } from "@reactive-resume/dto";
import { axios } from "@/client/libs/axios";

/**
 * ─────────────────────────────────────────────────────────────────────────────
 *  PROFIL PROFESSIONNEL — client API (GET/PATCH /profile/me)
 * ─────────────────────────────────────────────────────────────────────────────
 *  Le backend expose un upsert complet (contrats : libs/dto/src/profile).
 *  Les paramètres utilisateur n'utilisent pour l'instant que `phone` et
 *  `location` (critères de complétude de compte) ; les autres champs et
 *  collections restent disponibles pour les écrans futurs.
 * ─────────────────────────────────────────────────────────────────────────────
 */

/** Réponse GET /profile/me — user (socle) + profil professionnel. */
export type MyProfile = {
  id: string;
  name: string;
  email: string;
  picture: string | null;
  professionalProfile: {
    id: string;
    headline: string;
    summary: string;
    location: string;
    website: string;
    phone: string;
    linkedin: string;
    github: string;
    portfolioUrl: string;
  } | null;
};

export const fetchMyProfile = async (): Promise<MyProfile> => {
  const response = await axios.get<MyProfile>("/profile/me");
  return response.data;
};

/** Upsert du profil professionnel (payload partiel accepté par le backend). */
export const updateMyProfile = async (
  dto: Partial<
    Pick<
      ProfessionalProfileDto,
      | "phone"
      | "location"
      | "headline"
      | "summary"
      | "website"
      | "linkedin"
      | "github"
      | "portfolioUrl"
    >
  >,
): Promise<MyProfile> => {
  const response = await axios.patch<MyProfile>("/profile/me", dto);
  return response.data;
};
